export default __webpack_public_path__ + "static/media/happy_client2.d2a5eebd.png";